/**
 * @generated SignedSource<<a22836ffa1ae001cf8ebe4312b03a55b>>
 * @relayHash 30513cea64440f80f021c99363de424f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c561a3513f5d93226f3a192b2a9017fd566fd9d70a2675080e2b3c338c184335

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BusinessSummarySpaAppsQuery } from './BusinessSummarySpaAppsQuery.graphql';

const node: PreloadableConcreteRequest<BusinessSummarySpaAppsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c561a3513f5d93226f3a192b2a9017fd566fd9d70a2675080e2b3c338c184335",
    "metadata": {},
    "name": "BusinessSummarySpaAppsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
